import { trackEventAsync, generateRequiredProperties } from './index';

export const generateUIProperties = () => ({
  ...generateRequiredProperties(),
  eventVersion: 3,
  eventName: 'UI Action Performed',
});

export default {
  trackUpperSupportButtonEvent: (action: string): Promise<void> =>
    trackEventAsync({
      ...generateUIProperties(),
      eventProperties: {
        name: 'Negative Drug Screen Modal',
        data: { action },
      },
    }),
  trackDownloadPatientSnapshot: (patientId: string): Promise<void> =>
    trackEventAsync({
      ...generateUIProperties(),
      eventProperties: {
        name: 'Download Patient Snapshot',
        data: {
          patientId,
        },
      },
    }),
};
